import { type ReactElement, type SVGProps } from 'react';

export const ImageIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 5H4V15.7146L8.98429 10.2772L13.0637 14.3566L16.0637 12.3566L20 16.2929V5ZM4 19V17.1945L9.01571 11.7228L12.9363 15.6434L15.9363 13.6434L20 17.7071V19H4ZM3 4V20H21V4H3ZM17.5 8.5C17.5 9.05228 17.0523 9.5 16.5 9.5C15.9477 9.5 15.5 9.05228 15.5 8.5C15.5 7.94772 15.9477 7.5 16.5 7.5C17.0523 7.5 17.5 7.94772 17.5 8.5ZM18.5 8.5C18.5 9.60457 17.6046 10.5 16.5 10.5C15.3954 10.5 14.5 9.60457 14.5 8.5C14.5 7.39543 15.3954 6.5 16.5 6.5C17.6046 6.5 18.5 7.39543 18.5 8.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
